import React, { FormEvent, useState } from 'react';
import { Common } from '../../types/common';
import { ArrowUpIcon } from '../Icons';
import PageContentComponent from '../PageContentComponent';
import SocialLink from '../SocialLink';
import './styles.scss';

export type FooterProps = {
  data: Common
}

const Footer = ({ data }: FooterProps) => {
  const footer = data.sanityFooter;
  const settings = data.sanitySiteSettings;

  // const [email, setEmail] = useState('');
  // const [submitted, setSubmitted] = useState(false);
  // const [error, setError] = useState(false);

  const backToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  // async function handleSubscribe(event: FormEvent) {
  //   event.preventDefault();
  //   try {
  //     await fetch('https://nnri6tifkbko7mjei7lhqmg2wy0ftstf.lambda-url.us-east-1.on.aws/', {
  //       method: 'POST',
  //       body: JSON.stringify({ email, type: "newsletter" })
  //     }).then(response => {
  //       if (!response.ok) throw Error()
  //     });
  //   } catch {
  //     setError(true);
  //   } finally {
  //     setSubmitted(true);
  //   }
  // }

  return (
    <footer id="footer" className='footer-container'>
      <div className='wrapper'>
        {footer?.enableBackToTop && (
          <button
            onClick={() => backToTop()}
            className='back-to-top'
          >
            {footer?.backToTopText ? footer?.backToTopText : "Back to the top"}
            <ArrowUpIcon />
          </button>
        )}
        {/* <form
          className='footer-form'
          onSubmit={handleSubscribe}
        >
          <h3>Let's stay in touch</h3>
          {submitted && !error && (
            <>
              <p>Thank you for subscribing to our newsletter!</p>
              <p>You'll now receive the latest news and updates straight to your inbox. We appreciate your interest and look forward to staying in touch.</p>
            </>
          )}
          {submitted && error && (
            <>
              <h4 style={{ color: '#0B5C98', marginTop: '16px' }}>Send form error!</h4>
              <p>Try again later.</p>
            </>
          )}
          {!submitted && (
            <>
              <p>Get the latest peanut news, recipes, and health tips delivered straight to your inbox.</p>
              <div>
                <input
                  placeholder='Write your e-mail'
                  type='email'
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
                <button className='primary-button-small'>Subscribe</button>
              </div>
            </>
          )}
        </form> */}
        {footer?._rawSections && (
          <PageContentComponent
            content={footer?._rawSections}
          />
        )}
        {settings?.social && settings?.social.length > 0 && (
          <div className='footer-social'>
            {settings.social.map(link => (
              <SocialLink key={link._key} data={link} />
            ))}
          </div>
        )}
        <div className='footer-disclaimer'>
          <p>Links on this site may take you to third party websites not associated with the National Peanut Board. These links have been provided as a convenience. The National Peanut Board assumes no responsibility for the accuracy, quality, safety, or nature of the content on the linked sites.</p>
        </div>
      </div>
    </footer>
  )
};

export default Footer;
